// import rAF from one place so that the bundle size is a bit smaller
const rAF = requestAnimationFrame

export { rAF as requestAnimationFrame }
